module.exports = __webpack_public_path__ + "img/ayudas-diagnosticas.7fc614ae.jpg";